export const routes = {
  editor: {
    list: 'v3/editor/list',
    code: 'v3/editor/code',
    proxy: 'v3/editor/proxy',
    publish: 'v3/editor/publish-code',
    aiChat: 'v3/editor/ai-chat',
    aiChatAttachment: 'v3/editor/ai-chat/attachment',
  },
  user: {
    profile: 'v3/account/profile',
  },
};
